<template>
  <div class="comment">
    <fixed-header title="发表评价"></fixed-header>
    <div class="comment__main scroll-touch">
      <div v-for="(item, index) in form.items" :key="index" class="comment__item">
        <div :class="['comment__item-goods',index===0?'border_top':'']">
          <div><img :src="item.goodsImage" alt=""></div>
          <div>
            <i v-for="(ele, index2) in getNowStar(item.point)" :key="index2" :class="['icon', ele]"
               @click="changeStar(item,index2)"></i>
            <span>{{ getRankTitle(item.point) }}</span>
          </div>
        </div>
        <div class="comment__item-comment">
          <section>
            <textarea v-model="item.content" cols="30" placeholder="说说宝贝的优点缺点吧～～" rows="5"></textarea>
          </section>
          <section>
            <div v-for="(ele, index2) in item.imgs" :key="index2" class="comment__item-comment-img">
              <img :src="ele.src" alt="">
              <i class="icon comment_del" @click="deleteImg(item,index,index2)"></i>
            </div>
            <div class="comment__item-comment-upload" @click="clickUpload">
              <input v-if="isShowInput" id="upload" accept="image/*" multiple type="file"
                     @change="(e)=>uploadPic(e,item.goodsId,index)">
              <i class="icon camera"></i>
              <span>添加图片</span>
            </div>
          </section>
        </div>
      </div>
      <!--      <div class="comment__bottom" v-if="order.prom_type!=5">-->
      <!--        <p>-->
      <!--          <span>物流服务</span>-->
      <!--          <span>-->
      <!--            <i v-for="(ele, index) in getNowStar(form.deliver_rank)" :class="['icon', ele]" :key="index" @click="changeTransStar(index)"></i>-->
      <!--          </span>-->
      <!--        </p>-->
      <!--      </div>-->
    </div>
    <div :mg-stat-lob="`order_id=${id}&scoring=&logis=${form.deliverRank}`" class="comment__button"
         mg-stat-click
         mg-stat-custom="cont=保存&label=btn&direct=cntp&addr="
         @click="submitForm">
      <button>保存</button>
    </div>
  </div>
</template>

<script>
import FixedHeader from 'components/common/FixedHeader';
import OSS from 'ali-oss';
import * as orderApi from 'apis/order';
import * as commentApis from 'apis/comments';
import * as uploadApis from 'apis/upload';
import _ from 'lodash';
import { guid, isIosHalfWebview } from 'utils';

export default {
  components: {
    FixedHeader,
    OSS,
  },
  data() {
    const { id } = this.$route.query;
    return {
      id,
      form: {
        deliverRank: 0,
        orderId: id,
        items: [],
      },
      errorMsg: '',
      order: {},
    };
  },
  created() {
    this.fetchDetail();
  },
  computed: {
    isSupportUpload() {
      const str = navigator.userAgent.toLowerCase();
      const ver = str.match(/cpu iphone os (.*?) like mac os/);
      if (ver && Array.isArray(ver)) {
        const [version] = ver[1].replace(/_/g, '.').split('.');
        return Number(version) >= 11;
      }
      return true;
    },
    isShowInput() {
      return this.isSupportUpload && (!isIosHalfWebview());
    },
  },
  methods: {
    isIosHalfWebview,
    clickUpload() {
      if (!this.isSupportUpload) {
        this.$toast('您的系统不支持图片上传，请升级到11.0版本及以上');
      } else if (isIosHalfWebview()) {
        this.$toast('请到“我－芒果好物”添加照片评论');
      }
    },
    getRankTitle(rank) {
      switch (rank) {
        case 1:
          return '非常差';
        case 2:
          return '差';
        case 3:
          return '一般';
        case 4:
          return '好';
        case 5:
          return '非常好';
        default:
          return '';
      }
    },
    async fetchDetail() {
      const {
        id,
      } = this;
      if (!id) {
        return;
      }
      const data = await orderApi.getOrderDetail({
        orderId: id,
      });
      const arr = [];
      if (data && Array.isArray(data.orderGoodsList)) {
        this.order = data;
        data.orderGoodsList.forEach((f) => {
          if (f.isSend !== 3) { /* 退款成功的商品不让评价 */
            arr.push({
              goodsId: f.goodsId,
              recId: f.recId,
              goodsImage: f.originalImg,
              content: '',
              images: [],
              imgs: [],
              point: 5,
              isAnony: 0,
            });
          }
        });
        this.form.items = arr;
      }
    },
    deleteImg(item, index, index2) {
      item.imgs.splice(index2, 1);
      /* 删除图片时  文件也要同步删除 */
      this.form.items[index].images.splice(index2, 1);
    },
    async uploadPic(e, goods_id, index) {
      const files = e.target.files || e.dataTransfer.files;
      const {
        length,
      } = this.form.items[index].images;
      if (!files.length) {
        return;
      } else if (files.length > 6 || (length + files.length) > 6) {
        this.$toast({
          message: '最多上传6张图片',
          duration: 1000,
        });
        return;
      }
      try {
        this.$loading.open();
        // 获取oss配置信息
        const ossConfig = await uploadApis.getStsToken({ biz: 1, num: files.length });
        const bucketInfo = ossConfig.bucketInfo;
        const stsToken = ossConfig.stsToken;
        // 获取上传实例对象
        const client = new OSS({
          region: bucketInfo.region,
          accessKeyId: stsToken.accessKeyId,
          accessKeySecret: stsToken.accessKeySecret,
          stsToken: stsToken.securityToken,
          bucket: bucketInfo.bucket,
          endpoint: bucketInfo.endpoint,
        });
        Object.keys(files).forEach((key) => {
          const val = files[key];
          val.tagId = guid(); /* 分配一个id */
          const reader = new FileReader();
          reader.readAsDataURL(val);
          reader.onload = (e) => {
            const dataURL = reader.result;
            const img = new Image();
            img.src = dataURL;
            img.onload = async () => {
              const w = Math.min(400, img.width);
              const h = img.height * (w / img.width);
              const canvas = document.createElement('canvas');
              const ctx = canvas.getContext('2d');
              canvas.width = w;
              canvas.height = h;
              ctx.drawImage(img, 0, 0, w, h);
              const dataURL = canvas.toDataURL('image/png');
              const file = this.dataURLtoFile(dataURL, bucketInfo.keys[key]);
              const imgName = `${bucketInfo.keys[key]}.png`;
              await client.multipartUpload(imgName, file, {});
              const imgUrl = `$${bucketInfo.bucket}:${imgName}`;
              this.form.items[index].images.push(imgUrl);
            };
            this.form.items[index].imgs.push({
              src: e.target.result,
              tagId: val.tagId,
            });
          };
        });
        this.$loading.close();
      } catch (e) {
        this.$loading.close();
        this.$toast('图片上传失败');
      }
    },
    dataURLtoFile(dataurl, filename) {
      // 将base64转换为文件
      const arr = dataurl.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n >= 0) {
        u8arr[n] = bstr.charCodeAt(n);
        n -= 1;
      }
      return new File([u8arr], filename, { type: mime });
    },
    getNowStar(val) {
      const allStars = [];
      for (let i = 0; i < 5; i += 1) {
        if (i <= (val - 1)) {
          allStars.push('light_star');
        } else {
          allStars.push('gray_star');
        }
      }
      return allStars;
    },
    changeTransStar(index) {
      this.form.deliverRank = (index + 1);
    },
    changeStar(item, index) {
      item.point = (index + 1);
    },
    async submitForm() {
      const nowForm = _.cloneDeep(this.form);
      let count = 0;
      nowForm.items.forEach((f) => {
        if (!f.content || f.content.length < 2) {
          count += 1;
        }
      });
      if (count > 0) {
        this.$toast('请填写评论内容,至少两个字');
        return;
      }
      nowForm.items.forEach((f) => {
        delete f.imgs;
      });
      this.$loading.open();
      try {
        console.log(JSON.stringify(nowForm));
        await commentApis.addComment(nowForm);
        this.$toast({
          message: '提交成功',
          duration: 1000,
        });
        setTimeout(() => {
          this.$router.go(-1);
        }, 1000);
      } catch (error) {
        this.$toast(`提交失败：${error.message}`);
      }
      this.$loading.close();
    },
  },
};
</script>

<style lang="scss">
.comment {
  height: 100%;
  box-sizing: border-box;

  &__main {
    height: 100%;
  }

  .border_top {
    border-top: 2px solid rgba(211, 211, 211, 0.5);
  }

  &__item {
    background: #fff;
    margin-bottom: 20px;

    &-goods {
      padding: 20px 30px 20px 30px;
      border-bottom: 2px solid rgba(211, 211, 211, 0.5);
      display: flex;
      align-items: center;

      div:nth-child(1) {
        width: 112px;
        margin-right: 30px;

        img {
          max-width: 100%;
          height: 112px;
        }
      }

      div:nth-child(2) {
        height: 40px;
        display: flex;
        align-items: center;

        i {
          width: 36px;
          height: 35px;
          margin-right: 20px;
        }

        span {
          margin-left: 20px;
          font-size: 28px;
          color: #9B9B9B;
        }
      }
    }

    &-comment {
      padding: 20px 30px;

      textarea {
        width: 100%;
        font-size: 28px;
        word-break: break-all;
        border: none;
      }

      section:last-child {
        padding: 20px 0;
        display: flex;
        flex-wrap: wrap;
      }

      &-img {
        width: 148px;
        height: 148px;
        margin-right: 23px;
        margin-top: 20px;
        text-align: center;
        border-radius: 10px;
        position: relative;

        img {
          height: 100%;
          max-width: 100%;
          border-radius: 10px;
        }

        i {
          position: absolute;
          right: -15px;
          top: -20px;
        }
      }

      &-upload {
        width: 148px;
        height: 148px;
        margin-right: 23px;
        margin-top: 20px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        font-size: 22px;
        color: #9b9b9b;
        border: 1px dashed #9b9b9b;
        border-radius: 10px;

        span {
          margin-top: 10px;
        }

        input {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
        }
      }
    }
  }

  &__bottom {
    padding: 10px 30px;
    font-size: 28px;
    color: #000000;
    min-height: 300px;
    margin-bottom: 100px;

    i {
      width: 36px !important;
      height: 35px !important;
      margin-right: 20px;
    }

    p {
      display: flex;
      align-items: center;

      span:first-child {
        margin-right: 30px;
      }
    }
  }

  &__button {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 20px 30px;
    background: #F2F2F2;

    button {
      padding: 20px 0;
      width: 100%;
      font-size: 30px;
      color: #ffffff;
      background-image: linear-gradient(90deg, #fa841b 17%, #ff6002 85%);
      border-radius: 12px;
    }
  }
}
</style>
